
<template>
  <div class="face-container">
    <div class="scroll-wrapper">
      <div class="face-content"
        @touchmove.prevent
        ref="faceContent"
        :style="{ width: scrollWidth + 'px', marginLeft: -scrollPosition + 'px' }"
      >
        <div class="face-page"
          v-for="(page, index) in faces"
          :key="index">
          <a v-for="(item, j) in page"
            :key=j
            >
            <img @click="onFaceClick(`[${item.title}]`)" :src=item.src width="20" height="20">
          </a>
        </div>
      </div>
      <div class="page-dot">
        <div v-for="n in faces.length"
          @click="active = n - 1"
          :key=n class="dot-item"
          :class="n === (active + 1) ? 'active' : ''">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import face from './face'
export default {
  data: () => ({
    active: 0,
    faceData: face,
  }),
  computed: {
    faces() {
      const {faceData:list} = this
      let n = 0
      let listGrouped = []
      let keys = Object.keys(list)
      
      while (n * 21 < keys.length) {
        listGrouped.push(keys.slice(n * 21, (n + 1) * 21).map(( key )=>{
            return {'title':key,'src':list[key]}
        }))
        n += 1
      }
      return listGrouped
    },
    scrollWidth () {
      return this.faces.length * document.querySelector('#app').scrollWidth
    },
    scrollPosition () {

      return this.active * document.querySelector('#app').scrollWidth
    }
  },
  mounted () {
    const el = this.$refs.faceContent
    let x1 = 0
    let x2 = 0
    el.ontouchstart = (evt) => {
      x1 = evt.targetTouches[0].pageX
    }
    el.ontouchend = (evt) => {
      x2 = evt.changedTouches[0].pageX
      if (x2 - x1 > 50) {
        this.active !== 0 && this.active--
      } else if (x2 - x1 < -50) {
        this.active !== this.faces.length - 1 && this.active++
      }
    }
  },
  methods: {
    onFaceClick (face) {
      this.$emit('onFaceChoose', face)
    }
  }
}
</script>

<style scoped>
.face-container {
  width: 100%;
  background: #F6F6F6;
  display: flex;
  flex-direction: column;
}
.face-container .scroll-wrapper {
  width: 100%;
  height: 157px;
  border-top: solid 1px #DDDDDD;
  position: relative;
}
.face-container .scroll-wrapper .face-content {
  height: 100%;
  display: flex;
  transition: margin-left 0.5s;
}
.face-container .scroll-wrapper .face-content .face-page {
  width: 100%;
  height: 140px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.face-container .scroll-wrapper .face-content .face-page a {
  width: 14.28%;
  height: 33.33%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.face-container .scroll-wrapper .page-dot {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.face-container .scroll-wrapper .page-dot .dot-item {
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background: #CCCCCC;
  margin: 0 5px;
}
.face-container .scroll-wrapper .page-dot .dot-item.active {
  background: #FF8140;
}
.face-container .face-footer {
  position: relative;
  width: 100%;
  height: 36px;
  overflow-x: auto;
}
.face-container .face-footer .footer-title {
  width: 280px;
  height: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.face-container .face-footer .footer-title a {
  height: 100%;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.face-container .face-footer .footer-title a.active {
  background: #E9E9E9;
}
</style>
